import { useCallback, useEffect, useRef, useState } from 'react';

// Index of the step currently crossing the viewport's middle band (sticky walk-through / tour route).
export function useActiveIndex<T extends HTMLElement = HTMLElement>() {
  const [active, setActive] = useState(0);
  const nodes = useRef<(T | null)[]>([]);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) setActive(nodes.current.indexOf(e.target as T));
      }),
      { rootMargin: '-45% 0px -45% 0px' },
    );
    nodes.current.forEach((n) => n && io.observe(n));
    return () => io.disconnect();
  }, []);

  const register = useCallback((i: number) => (el: T | null) => { nodes.current[i] = el; }, []);
  return { active, register };
}
